import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { $vuetify } from "./plugins/vuetify";
import { $plugins } from "./plugins";
import "@mdi/font/css/materialdesignicons.css";

const pinia = createPinia();

export const app = createApp(App);
app.use(router).use(pinia).use($vuetify).use($plugins).mount("#app");
